import {apiGlobal} from './index'
import {LOCAL_STORAGE} from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const examEndPoints = {
  INIT_EXAM: 'iesv/api/v1/test/init',
  SEND_AUDIO_EXAM: 'iesv/api/v1/test/retrieve-texts',
  GET_EXAM_RESULTS: 'iesv/api/v1/test/results',
  GET_EXAM_RESULT_FAKE: 'iesv/api/v1/test/result-fake',
  SEND_DATA_ANSWER: 'iesv/api/v1/test/answers',
}

const examRequest = {
  getExamResults: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${examEndPoints.GET_EXAM_RESULTS}`, {})
    }
    return apiGlobal.get(`${examEndPoints.GET_EXAM_RESULTS}`, {})
  },
  getExamResultDetail: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${examEndPoints.GET_EXAM_RESULTS}/${params}`,
        {},
      )
    }
    return apiGlobal.get(`${examEndPoints.GET_EXAM_RESULTS}/${params}`, {})
  },
  getExamResultFake: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${examEndPoints.GET_EXAM_RESULT_FAKE}`, {})
    }
    return apiGlobal.get(`${examEndPoints.GET_EXAM_RESULT_FAKE}`, {})
  },
  sendAudioExam: (params: any) => {
    // try 'Content-Type': 'audio/mpeg' || 'audio/wav'
    if (getAccessToken()) {
      return apiGlobal.authPost(examEndPoints.SEND_AUDIO_EXAM, params, {}, true)
    }
    return apiGlobal.post(examEndPoints.SEND_AUDIO_EXAM, params, {}, true)
  },
  initExam: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(examEndPoints.INIT_EXAM, params)
    }
    return apiGlobal.post(examEndPoints.INIT_EXAM, params)
  },
  sendDataAnswer: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(`${examEndPoints.SEND_DATA_ANSWER}`, params, {})
    }
  },
}

export default examRequest
